// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + {"264":"series","353":"contact","450":"dynamic","594":"about"}[chunkId] + "." + {"264":"32b4277b","353":"26a2da57","450":"2d0733ff","594":"4253ddbc"}[chunkId] + ".js";
};